import { Navigate } from 'react-router-dom';
import { useOrg } from '../components/OrgContext';
import { homeKindFor } from './company';

// /cases/attention, /cases/open, /cases/matched and /cases/done (redesign step 3; dev website only: App.tsx registers them only when
// the release switch is on). A pure agent gets the list; everyone else is sent to today's Cases page (/cases), which is unchanged.
export default function CasesListEntry({ list }) {
  const { capabilities } = useOrg();
  return homeKindFor(capabilities) === 'agent' ? list : <Navigate to="/cases" replace />;
}
